module.exports = {
    OKCONSENTS_CONSENTS: 'CONSENT',
    OKCONSENTS_EMPTY_VALUE: 'PENDING',
    OKCONSENTS_NEGATIVE_VALUE:'NOT_ACCEPTED',
    OKCONSENTS_POSITIVE_VALUE: 'ACCEPTED',
    OKCONSENTS_LEGITIMATE: 'LEGITIMATE',
    OKCONSENTS_CONSENTS_SWITCH: 'switch',
    OKCONSENTS_CONSENTS_CHECKBOX: 'checkbox'
};
